import { get, isArray } from 'lodash';
import React, { FC } from 'react';
import CreateTable from 'src/components/ui-component/form-component/create-form/CreateTable';
import { useApplication } from 'src/context/ApplicationContext';
import { FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS } from 'src/lib/constants/componentsPath';
import { FORM_FIELDS_TYPES } from 'src/lib/constants/constant';

// import schemas
import AntragSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import { FormStrucItem } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { addIndexesToPath } from 'src/utils/helper';
const P = AntragSchema.attributes;

const OptionaleAnlagenMA: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const foerderprogramm = get(application, P.Foerderantrag.schema.attributes.Foerderprogramm.path, {});
	const paths = FOERDERPROGRAMM_ERKLAERUNG_UND_UNTERLAGEN_MA_PATHS;

	return (
		<>
			<ApplicationHeading
				title={get(foerderprogramm, paths.OptionaleAnlageUnterTitel, 'Optionale Anlagen')}
				description={get(foerderprogramm, paths.OptionaleAnlageBeschreibung, '')}
			/>

			<CreateTable
				formStruc={formStrucOptionaleAnlagen(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
				columnsLabel={columnLabels()}
				size='small'
			/>
		</>
	);
};

export default OptionaleAnlagenMA;

const columnLabels = () => {
	let labels = [{ label: 'Bezeichnung des Dokuments' }, 'Datei', 'Bemerkungen'];
	return labels;
};

const formStrucOptionaleAnlagen = (application: any) => {
	let struc: FormStrucItem[] = [];
	const optionaleAnlagen = get(application, P.Anlagen_Optionale_Anlagen.path, []);

	if (isArray(optionaleAnlagen) && optionaleAnlagen.length > 0) {
		for (const [i, ele] of optionaleAnlagen.entries()) {
			if (get(ele, 'Bezeichnung_Des_Dokuments')) {
				struc.push({
					fields: [
						{
							type: FORM_FIELDS_TYPES.label,
							path: 't.t',
							label: get(ele, 'Bezeichnung_Des_Dokuments'),
							tooltip: get(ele, 'Erlaeuterungen_Zum_Dokument', ''),
						},
						{
							type: P.Anlagen_Optionale_Anlagen.schema.attributes.Datei.type,
							path: addIndexesToPath(P.Anlagen_Optionale_Anlagen.schema.attributes.Datei.path, [`${i}`], ['Anlagen_Optionale_Anlagen']),
						},
						{
							type: P.Anlagen_Optionale_Anlagen.schema.attributes.Bemerkung_Der_Antragsteller.type,
							path: addIndexesToPath(
								P.Anlagen_Optionale_Anlagen.schema.attributes.Bemerkung_Der_Antragsteller.path,
								[`${i}`],
								['Anlagen_Optionale_Anlagen'],
							),
						},
					],
				});
			}
		}
	}
	return struc;
};
